import { createContext, useContext, useEffect, useState } from "react";

const Ctx = createContext(null);
const KEY = "sj_selection";

const load = () => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY));
    return { ids: Array.isArray(v?.ids) ? v.ids : [], client: v?.client || "", project: v?.project || "" };
  } catch {
    return { ids: [], client: "", project: "" };
  }
};

export const ShortlistProvider = ({ children }) => {
  const [state, setState] = useState(load);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify(state));
  }, [state]);

  const toggle = (id) => setState((s) => ({ ...s, ids: s.ids.includes(id) ? s.ids.filter((x) => x !== id) : [...s.ids, id] }));
  const has = (id) => state.ids.includes(id);
  const clear = () => setState((s) => ({ ...s, ids: [] }));
  const setMeta = (k, v) => setState((s) => ({ ...s, [k]: v }));
  const addMany = (list) => setState((s) => ({ ...s, ids: [...new Set([...s.ids, ...list])] }));

  return <Ctx.Provider value={{ ...state, toggle, has, clear, setMeta, addMany }}>{children}</Ctx.Provider>;
};

export const useShortlist = () => useContext(Ctx);
